const initialState = {
  list: [],
  isLoaded: false,
  lastFetchTime: null,
};

const announcementListReducers = (state = initialState, action) => {
  switch (action.type) {
    case "storeAnnouncementList":
      return {
        ...state,
        list: action.payload,
        isLoaded: true,
        lastFetchTime: Date.now(),
      };

    case "clearAnnouncementList":
      return initialState;

    default:
      return initialState;
  }
};

export default announcementListReducers;
